import { useHistory } from '@lib/router';
import { Path } from '@components/routes/constants';
import useStores from '@stores/useStores';
import { webapp } from '@lib/analytics';

type UpgradeCtaClickedProps = Parameters<typeof webapp.trackUpgradeCtaClicked>[0];

/**
 * Analytics context passed to the upgrade navigation hook. When provided, the returned
 * callback fires `webapp.upgradeCtaClicked` before navigating so funnel attribution can
 * track which surface drove the click.
 */
type UpgradeCtaTrackContext = Pick<
  UpgradeCtaClickedProps,
  'ctaLocation' | 'ctaText' | 'destinationPage' | 'triggerContext'
>;

/**
 * Shared hook for navigating to the plans/upgrade page.
 * Used by all trial container components.
 *
 * @param trackContext When provided, fires `webapp.upgradeCtaClicked` before navigation.
 *                     Omit for callers that don't need analytics (or aren't instrumented yet).
 */
export const useUpgradeNavigation = (trackContext?: UpgradeCtaTrackContext) => {
  const { userStore } = useStores();
  const history = useHistory();
  if (!userStore.isOrgAdmin) {
    return undefined;
  }
  return () => {
    if (trackContext) {
      webapp.trackUpgradeCtaClicked(trackContext);
    }
    history.push(`${Path.ORGANIZATION}?tab=plans`);
  };
};
